"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductLimits = void 0;
var _react = require("react");
var _contexts = require("../../../../contexts");
var _utils = require("../../../../utils");
const useProductLimits = ({
  offerItem
}) => {
  const {
    offer: {
      availablePoints
    },
    isCampaignOffer,
    remainingAmount,
    remainingQuantity = Number.POSITIVE_INFINITY,
    selectedOfferItems
  } = (0, _contexts.useOfferDetail)();
  const {
    quantity
  } = selectedOfferItems.find(item => item.itemCode === offerItem.itemCode) ?? {
    quantity: 0
  };
  const {
    amount,
    points,
    maxQuantityToBuy: maxItemQuantityToBuy
  } = offerItem;
  const remainingItemQuantity = (0, _react.useMemo)(() => (0, _utils.getRemainingItemQuantity)({
    maxItemQuantityToBuy,
    quantity
  }), [maxItemQuantityToBuy, quantity]);
  const remainingQuantityPerAmount = (0, _react.useMemo)(() => (0, _utils.getRemainingQuantityPerAmount)({
    amount,
    remainingAmount
  }), [amount, remainingAmount]);
  const remainingQuantityPerPoints = (0, _react.useMemo)(() => (0, _utils.getRemainingQuantityPerPoints)({
    isCampaignOffer,
    availablePoints,
    points
  }), [availablePoints, isCampaignOffer, points]);
  return {
    maxQuantityToBuy: quantity + Math.min(remainingQuantity, remainingItemQuantity, remainingQuantityPerAmount, remainingQuantityPerPoints),
    quantity,
    remainingQuantity,
    remainingItemQuantity,
    remainingQuantityPerAmount,
    remainingQuantityPerPoints
  };
};
exports.useProductLimits = useProductLimits;